// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".a-sticky__container[data-v-3f496dc8]{position:-webkit-sticky;position:sticky}.a-sticky__mocked-space[data-v-3f496dc8]{visibility:hidden}", ""]);
// Exports
module.exports = exports;
